import { NgModule } from '@angular/core';

import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatSliderModule } from '@angular/material/slider';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
    imports: [
        MatToolbarModule,
        MatCardModule,
        MatListModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatTabsModule,
        MatTableModule,
        MatTooltipModule,
        MatInputModule,
        MatDividerModule,
        MatButtonModule,
        MatDialogModule,
        MatSelectModule,
        MatSnackBarModule,
        MatProgressBarModule,
        MatCheckboxModule,
        MatRadioModule,
        MatSidenavModule,
        MatSliderModule,
        MatMenuModule,
        MatSortModule
    ],
    exports: [
        MatToolbarModule,
        MatCardModule,
        MatListModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatTabsModule,
        MatTableModule,
        MatTooltipModule,
        MatInputModule,
        MatDividerModule,
        MatButtonModule,
        MatDialogModule,
        MatSelectModule,
        MatSnackBarModule,
        MatProgressBarModule,
        MatCheckboxModule,
        MatRadioModule,
        MatSidenavModule,
        MatSliderModule,
        MatMenuModule,
        MatSortModule
    ]
})
export class MaterialModule { }
